import { Component, input } from '@angular/core';
import { MatLabel } from '@angular/material/form-field';

@Component({
	selector: 'lvr-field',
	template: `
		@if (label()) {
			<mat-label>{{ label() }}</mat-label>
		}
		<ng-content></ng-content>
	`,
	styles: [
		`
			:host {
				display: block;
			}
		`,
	],
	imports: [MatLabel],
})
export class LvrField {
	public readonly label = input<string>('');
}
